import {
    DialogSize,
    RaikoAlert,
    raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoDefaultDialogPage,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMobileInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {ResidencesManagerService} from "../../../serverService/residencesManagerService/ResidencesManagerService";
import ResidenceManagerRegisterResultInfo from "./ResidenceManagerRegisterResultInfo";

export default function AddNewResidenceManager({needRefreshState}) {

    const [clerkPersianName, setClerkPersianName] = useState("");
    const [clerkPhoneNumber, setClerkPhoneNumber] = useState("");
    const [userName, setUserName] = useState("")
    const [openRegisterResultDialog, setOpenRegisterResultDialog] = useState(false);
    const [adminUsername, setAdminUsername] = useState("");
    const [adminPassword, setAdminPassword] = useState("");

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new ResidencesManagerService()


    function handleAddNewResidenceManager() {
        loading.show()
        service.addNewClerk(clerkPersianName, clerkPhoneNumber, userName)
            .then(response => {
                needRefreshState(true)
                setAdminPassword(response.password)
                setAdminUsername(response.username)
                setOpenRegisterResultDialog(true)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            loading.hide()
        })

    }

    function handleCloseRegisterResultDialog() {
        setOpenRegisterResultDialog(false);
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseRegisterResultDialog}
                open={openRegisterResultDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"اطلاعات ورود خادم"}
            >
                <ResidenceManagerRegisterResultInfo
                    handleCloseDialog={handleCloseRegisterResultDialog}
                    alertTitle={"خادم جدید با موفقیت افزوده شد."}
                    alertDescription={[
                        `* نام کاربری، گذر واژه و نشانی سامانه از طریق پیامک (${clerkPhoneNumber}) برای خادم محترم ارسال شد.`,
                    ]}
                    username={adminUsername}
                    password={adminPassword}/>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>

                <RaikoSectionContainer
                    title={"افزودن خادم"}
                    subTitle={"بعد از افزودن خادم جدید به طور خودکار پیامکی حاوی اطلاعات ورود و نشانی سامانه برای خادم ارسال خواهد شد، لطفا در ورود شماره ی همراه خادم دقت لازم را به همراه داشته باشید."}
                    hasActionButton={true} actionButtonTitle={"افزودن"}
                    actionButtonOnclickWithValidation={handleAddNewResidenceManager}>
                    <RaikoGridOneColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"نام و نام خانوادگی"}
                            value={clerkPersianName}
                            setValue={setClerkPersianName}
                            required
                        />
                        <RaikoMobileInputOutlined
                            labelText={"شماره همراه"}
                            value={clerkPhoneNumber}
                            setValue={setClerkPhoneNumber}
                            required
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"نام کاربری"}
                            value={userName}
                            setValue={setUserName}
                            required
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </>

    )
}